import React from 'react'
import CakeList from './Cakes/Cakes'
import Hero from './Hero/Hero'

const LandingPage = () => {
  return (
    <>
        <Hero />
        <CakeList />
    </>
  )
}

export default LandingPage